export default __webpack_public_path__ + "static/media/asdev_internship.e33bd750.jpg";